import { h, Fragment } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import { Filter } from './Filter';
import styles from './FilterPanel.module.scss';
export function FilterPanel({ filters, onFilterChange, layout, openFilterDrawer, setOpenFilterDrawer, onMobileClick }) {
    const [openFilterId, setOpenFilterId] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    const panelRef = useRef(null);
    // Check if we're on mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 1200);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                setOpenFilterId(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (h(Fragment, null,
        layout === 'filterDrawer' && (h("div", { class: styles.filterPanelHeader },
            h("div", { class: "filter-panel-heading" }, "Filters"),
            h("div", { class: "filter-panel-close", onClick: () => setOpenFilterDrawer(!openFilterDrawer) },
                h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", class: styles.iconClose },
                    h("g", { "clip-path": "url(#clip0_103_2583)" },
                        h("path", { d: "M1 1L15 15M1 15L15 1", stroke: "black" })),
                    h("defs", null,
                        h("clipPath", { id: "clip0_103_2583" },
                            h("rect", { width: "16", height: "16", fill: "white" }))))))),
        h("div", { class: styles.filterPanelWrapper, ref: panelRef },
            h("div", { class: styles.filterPanel }, filters
                .filter(filter => filter.type !== 'range') // Hide price range filters
                .map(filter => (h(Filter, { layout: layout, key: filter.id, filter: filter, onFilterChange: onFilterChange, isOpen: openFilterId === filter.id, onToggle: () => {
                    if (isMobile && onMobileClick) {
                        onMobileClick(filter.id);
                    }
                    else {
                        setOpenFilterId(openFilterId === filter.id ? null : filter.id);
                    }
                } })))))));
}
